/* eslint-disable no-bitwise */

// Yellow animated circle to find the maximized channel guide.
export const GUIDE_MAXIMIZED = 1 << 0;

// shows the download app notification if a user is in mobile
export const DOWNLOAD_APP_NOTIFICATION_ALREADY_DISMISSED = 1 << 1;

// On first time the user enters WAM, we need to show a special welcome/help dialog
export const WAM_D0_ALREADY_DISMISSED = 1 << 2;

// export const ANOTHER_FEATURE_1 = 1 << 2;
// export const ANOTHER_FEATURE_2 = 1 << 3;
// export const ANOTHER_FEATURE_3 = 1 << 4;
// .. up to 32
// export const ANOTHER_FEATURE = 1 << 31;
